import { Grid, IconButton, MenuItem, Popover } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import {
  OverviewCard,
  PageTitleAndSubTitle,
  Table,
  CardComponent,
  PieChartWithoutCard,
  CostTrend,
  DashedStandardDropdown,
  Breadcrumbs,
  Button,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import properties from '../../core-utils/properties';
import careQualityInternalMessages from '../../core-utils/messages/careQualityInternalMessages';
import Loader from '../../_components/molecules/Loader';
import { observer } from 'mobx-react';
import { useStores } from '../../stores';
import ScrollDown from '../../_components/atoms/ScrollDown';
import { CircularLoader, Typography } from '@HomaHealth/ui-component-library';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { Pagination } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import FeatureAccessModal from '../../_components/organisms/FeatureAccessModal';
import { toJS } from 'mobx';
import { getMediumEmphasisText } from '../../core-utils/helper-utils/homePageHelper';
import { formatDate } from '../../core-utils/helper-utils/helper';
import { useNavigate } from 'react-router-dom';
import {
  CARE_QUALITY,
  CARE_QUALITY_INTERNAL,
  PATIENT_DETAILS,
} from '../../core-utils/routes';
import {
  COMMON_TEXTS,
  scrollBarStyles,
} from '../../core-utils/messages/CommonConstants';
import moment from 'moment';
import {
  formatMemberDistributionAge,
  formatMemberDistributionGender,
  formatMemberDistributionRisk,
  formatSummaryCards,
  formatTopServiceType,
  PieChartdata,
  SummaryCards,
} from '../../core-utils/helper-utils/careQualityInternalHelper';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import { getLast12MonthsRange } from '../CareQualityPage';
import { getCareQualityDistributions } from '../../core-utils/helper-utils/careQualityHelper';
import EditDurationModal from '../../_components/molecules/EditDurationModal';
import { DynamicFilter } from '../../_components/molecules/DynamicFilter';
import SvgDropDown from '@HomaHealth/ui-component-library/lib/_components/atoms/Icons/DropDown';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';

export interface SummaryPageProps { }

export const pageScrollDown = (elementId: string) => {
  const handleClickScrollDown = () => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        right: 0,
        bottom: 0,
        padding: '0px 16px 16px 0px',
      }}
    >
      <ScrollDown onClick={() => handleClickScrollDown()} showPageDown={true} />
    </div>
  );
};

const CareQualityInternalPage: React.FC<SummaryPageProps> = observer(({ }) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
    },
    scroll: scrollBarStyles,
    duration: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: '230px',
      height: '27px',
      background: patientAccessTheme.palette.status.white,
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderRadius: '4px',
      color: patientAccessTheme.palette.text.highemphasis,
      padding: '0px',
    },
  });

  const statusMap: any = {
    met: 'Compliant',
    Notmet: 'Not-Compliant',
    'Not Enough Data': 'Not Enough Data',
  };

  const { classes } = useStyles();
  const messages = careQualityInternalMessages.CARE_QUALITY_INTERNAL_PAGE;

  const [loading, setLoading] = useState<boolean>(true);
  const [memberDistLoading, setMemberDistLoading] = useState<boolean>(false);
  const [isMemberDetailsLoading, setIsMemberDetailsLoading] = useState<boolean>(
    false,
  );

  const employerGroupStore = useStores().employerGroupStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const loginPageStore = useStores().loginPageStore;
  const careQualityStore = useStores().careQualityStore;
  const recommendedTabStore = useStores().recommendedTabStore;
  const memberSummaryStore = useStores().memberSummaryStore;

  const navigate = useNavigate();
  const { open, openModal, closeModal, isEditMode } = useCohortModal();

  // ✅ Refs to prevent duplicate API calls
  const chartsFetchedRef = useRef(false);
  const membersFetchedRef = useRef(false);

  const [summaryCards, setSummaryCards] = useState<SummaryCards>({
    currentRate: 0,
    previousRate: 0,
    eligible: 0,
    compliant: 0,
    nonCompliant: 0,
    notEnoughData: 0,
    target: 0,
  });

  const [topChart, setTopChart] = useState<string>('Risk');
  const [riskChartData, setRiskChartData] = useState<any>([]);
  const [ageChartData, setAgeChartData] = useState<any>([]);
  const [genderChartData, setGenderChartData] = useState<any>([]);
  const [topServiceType, setTopServiceType] = useState<PieChartdata>({
    data: [],
    legend: [],
  });

  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const { totalResults, memberIds, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () => getCareGapMemberSummaryIds(),
    enabled:
      !!startDate &&
      !!endDate &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
    isInternal: true,
    deps: [careQualityStore?.currentMeasure],
  });

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        recommendedTabStore?.categoryToBeCalled,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const [sortField, setSortField] = useState<string>('member_unique_id');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({ open: true, message, severity, duration });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  // ✅ Changed from boolean toggle to numeric counter to avoid double-fire
  const [areDatesReady, setAreDatesReady] = useState<number>(0);

  const [membersDetails, setMembersDetails] = useState<any>([]);
  const [pageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState<number>(2);
  const [selectedStatus, setSelectedStatus] = React.useState<string | null>(
    null,
  );
  const [selectedPrimaryCare, setSelectedPrimaryCare] = React.useState<
    string | null
  >(null);
  const [resetKey, setResetKey] = useState(0);
  const [statusCounts, setStatusCounts] = useState<Record<string, number>>({});

  const statusOptions = Object.keys(statusCounts).map(
    (key) => statusMap[key] || key,
  );

  const filterOptions = React.useMemo(
    () => [
      {
        label: 'Status',
        options: statusOptions,
        selected: selectedStatus ? statusMap[selectedStatus] : null,

        onChange: (label: string) => {
          const raw = Object.keys(statusMap).find(
            (key) => statusMap[key] === label,
          );
          membersFetchedRef.current = false;
          setSelectedStatus(raw || null);
          setSelectedPrimaryCare(null);
          setPageNumber(1);
        },
      },
      {
        label: 'Primary Care',
        options: ['YES', 'NO'],
        selected: selectedPrimaryCare,
        onChange: (label: string) => {
          membersFetchedRef.current = false;
          setSelectedPrimaryCare(label || null);
          setSelectedStatus(null);
          setPageNumber(1);
        },
      },
    ],
    [statusOptions, selectedStatus, selectedPrimaryCare],
  );

  // ✅ Memoized requestBody to avoid recreating on every render
  const requestBody3 = React.useMemo(
    () => ({
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      rule_id: careQualityStore.ruleId,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
      pageNumber: pageNumber - 1,
      pageSize,
      status: selectedStatus,
      primaryCare: selectedPrimaryCare,
      sortField,
      sortOrder,
    }),
    [
      pageNumber,
      selectedStatus,
      selectedPrimaryCare,
      sortField,
      sortOrder,
      cohortDetailsStore.memberUniqueIdList,
      employerGroupStore?.employerGroupResponseData?.eg_nid,
      careQualityStore.ruleId,
    ],
  );

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    membersFetchedRef.current = false;
    setPageNumber(value);
  };

  const handleDateChange = () => {
    setStartDate(employerGroupStore?.selectedDuration?.startDate);
    setEndDate(employerGroupStore?.selectedDuration?.endDate);
    // ✅ Reset refs so date change forces re-fetch
    chartsFetchedRef.current = false;
    membersFetchedRef.current = false;
    setAreDatesReady((prev) => prev + 1);
  };

  const getCareQualityInternalSummary = () => {
    return axios.post(
      properties.aiqBaseUrl +
      properties.careQualityInternalBasicUrl +
      properties.careQualityInternalSummary,
      {
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        rule_id: careQualityStore.ruleId,
        max_claim_date:
          employerGroupStore.employerGroupResponseData.max_claim_date,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      },
    );
  };

  const getTopServiceType = () => {
    return axios.post(
      properties.aiqBaseUrl +
      properties.careQualityInternalBasicUrl +
      properties.topServiceType,
      {
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        rule_id: careQualityStore.ruleId,
        max_claim_date:
          employerGroupStore.employerGroupResponseData.max_claim_date,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      },
    );
  };

  const getMemberDistribution = async (chartType: string) => {
    setMemberDistLoading(true);

    if (chartType === 'Risk') {
      await axios
        .post(
          properties.aiqBaseUrl +
          properties.careQualityInternalBasicUrl +
          properties.memberDistributionRisk,
          {
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
            rule_id: careQualityStore.ruleId,
            max_claim_date:
              employerGroupStore.employerGroupResponseData.max_claim_date,
            member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          },
        )
        .then((res) => {
          if (res?.status === 200) {
            setRiskChartData(formatMemberDistributionRisk(res?.data?.data));
          }
        })
        .catch((error) => {
          handleOpenSnackBar(error.response?.data?.error, 'error', 8000);
        });
    } else if (chartType === 'Age') {
      await axios
        .post(
          properties.aiqBaseUrl +
          properties.careQualityInternalBasicUrl +
          properties.memberDistributionAge,
          {
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
            rule_id: careQualityStore.ruleId,
            max_claim_date:
              employerGroupStore.employerGroupResponseData.max_claim_date,
            member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          },
        )
        .then((res) => {
          if (res?.status === 200) {
            setAgeChartData(formatMemberDistributionAge(res?.data?.data));
          }
        })
        .catch((error) => {
          handleOpenSnackBar(error.response?.data?.error, 'error', 8000);
        });
    } else {
      await axios
        .post(
          properties.aiqBaseUrl +
          properties.careQualityInternalBasicUrl +
          properties.memberDistributionGender,
          {
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
            rule_id: careQualityStore.ruleId,
            max_claim_date:
              employerGroupStore.employerGroupResponseData.max_claim_date,
            member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          },
        )
        .then((res) => {
          if (res?.status === 200) {
            setGenderChartData(formatMemberDistributionGender(res?.data?.data));
          }
        })
        .catch((error) => {
          handleOpenSnackBar(error.response?.data?.error, 'error', 8000);
        });
    }

    setMemberDistLoading(false);
  };

  const getCareGapMemberSummaryIds = async (): Promise<{
    noOfMemberIds: number;
    member_unique_ids: string[];
  }> => {
    const res = await axios.post(
      properties.aiqBaseUrl +
      properties.careQualityInternalBasicUrl +
      properties.careQualityMemberSummaryIds,
      {
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        rule_ids: careQualityStore.ruleId,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
        startDate,
        endDate,
      },
    );

    return res.data.data;
  };

  const handleChartChange = (event: any) => {
    setTopChart(event.target.value);
    getMemberDistribution(event.target.value);
  };

  const getMembersDetails = async (
    requestBody: any,
    setMembersDetails: any,
    setTotalPages: any,
  ) => {
    setIsMemberDetailsLoading(true);
    await axios
      .post(
        properties.aiqBaseUrl +
        properties.careQualityInternalBasicUrl +
        properties.careQualityInternalMemberSummary,
        requestBody,
      )
      .then((res) => {
        if (res?.status === 200) {
          setMembersDetails(res?.data?.data?.[0]?.dataSet);
          setTotalPages(
            Math.ceil(res?.data?.data?.[0]?.count?.[0]?.totalCount / 10),
          );
          const statusCountsArray = res?.data?.data?.[0]?.statusCounts ?? [];
          const statusCountsMap = statusCountsArray.reduce(
            (
              acc: Record<string, number>,
              item: { _id: string; count: number },
            ) => {
              acc[item._id] = item.count;
              return acc;
            },
            {},
          );
          setStatusCounts(statusCountsMap);
        }
      })
      .catch((error) => error);
    setIsMemberDetailsLoading(false);
  };

  const getAllCharts = async () => {
    setLoading(true);

    if (startDate !== '' && endDate !== '') {
      await Promise.allSettled([
        getCareQualityInternalSummary(),
        getTopServiceType(),
      ]).then((responses: any) => {
        responses.map((res: any) => {
          if (res.status !== 'fulfilled') {
            handleOpenSnackBar(res.reason.message, 'error', 6000);
          }
        });
        if (responses[0]?.status === 'fulfilled') {
          setSummaryCards(formatSummaryCards(responses[0]?.value?.data?.data));
        }
        if (responses[1]?.status === 'fulfilled') {
          setTopServiceType(
            formatTopServiceType(responses[1]?.value?.data?.data),
          );
        }
      });
    }

    if (careQualityStore?.careQualityMeasuresList?.length === 0) {
      const handleNonCompliantMembersList = (
        careQualityDistributionTableData: any,
      ) => {
        const localCareQualityMeasuresList: string[] = [];
        const localCareQualityMeasuresSubMeasure: Map<string, string> = new Map<
          string,
          string
        >();
        const localCareQualityMeasureRuleID: Map<string, string> = new Map<
          string,
          string
        >();
    
        careQualityDistributionTableData?.map((careQualityMeasureObject: any) => {
          careQualityMeasureObject?.individualMeasures?.map(
            (individualCareQualityMeasure: any) => {
              localCareQualityMeasuresList.push(
                individualCareQualityMeasure?.individualMeasure,
              );
              localCareQualityMeasuresSubMeasure.set(
                individualCareQualityMeasure?.individualMeasure,
                careQualityMeasureObject?.subMeasure,
              );
              localCareQualityMeasureRuleID.set(
                individualCareQualityMeasure?.individualMeasure,
                individualCareQualityMeasure?.ruleId,
              );
            },
          );
        });
    
        careQualityStore.removeAllData();
        careQualityStore.setCareQualityMeasuresList(localCareQualityMeasuresList);
        careQualityStore.setCareQualityMeasuresSubMeasure(
          localCareQualityMeasuresSubMeasure,
        );
        careQualityStore.setcareQualityMeasureRuleID(localCareQualityMeasureRuleID);
      };

      await getCareQualityDistributions(
        {
          startDate,
          endDate,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        (data: any) => handleNonCompliantMembersList(data?.distribution || []),
        null,
        () => {},
      );
    }

    setLoading(false);
  };

  const isScatterPlot = () => {
    return (
      careQualityStore?.subMeasure === 'Diabetes' ||
      careQualityStore?.subMeasure === 'Cardiovascular Conditions' ||
      careQualityStore?.subMeasure === 'Respiratory Conditions' ||
      careQualityStore?.subMeasure === 'Musculoskeletal Conditions' ||
      careQualityStore?.subMeasure === 'Behavioral Health' ||
      (careQualityStore?.subMeasure === 'Prevention And Screening' &&
        careQualityStore?.ruleId === 'CMS125v12') ||
      (careQualityStore?.subMeasure === 'Prevention And Screening' &&
        careQualityStore?.ruleId === 'CMS124v12') ||
      (careQualityStore?.subMeasure === 'Prevention And Screening' &&
        careQualityStore?.ruleId === 'CMS130v12')
    );
  };

  // ✅ Charts useEffect — guarded by ref to prevent duplicate calls
  useEffect(() => {
    if (isInitializing) {
      return;
    }
    if (!startDate || !endDate) {
      return;
    }

    chartsFetchedRef.current = true;

    if (isScatterPlot()) {
      setTopChart('Risk');
      getMemberDistribution('Risk');
    } else {
      setTopChart('Age');
      getMemberDistribution('Age');
    }
    getAllCharts();
  }, [
    isInitializing,
    startDate, // ✅ ADD
    endDate,
    areDatesReady,
    cohortDetailsStore.conditionsDetails,
    careQualityStore?.currentMeasure,
    employerGroupStore?.employerGroupResponseData?.eg_nid,
    cohortDetailsStore.memberUniqueIdList,
  ]);

  // ✅ Members useEffect — guarded by ref, but pagination/filter/sort changes always allowed
  useEffect(() => {
    if (!startDate || !endDate) {
      return;
    }

    // ✅ For filter/sort/page changes — always fetch (reset ref first)
    const isFilterOrSortOrPageChange =
      pageNumber !== 1 ||
      selectedStatus !== null ||
      selectedPrimaryCare !== null ||
      sortField !== 'member_unique_id' ||
      sortOrder !== 'asc';

    if (!membersFetchedRef.current || isFilterOrSortOrPageChange) {
      membersFetchedRef.current = true;
      getMembersDetails(requestBody3, setMembersDetails, setTotalPages);
    }
  }, [
    pageNumber,
    areDatesReady,
    cohortDetailsStore.conditionsDetails,
    careQualityStore?.currentMeasure,
    selectedStatus,
    selectedPrimaryCare,
    sortField,
    sortOrder,
  ]);

  // ✅ Initialise dates — set to true once, not toggled
  useEffect(() => {
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }

    // ✅ Reset refs when eg_nid changes so fresh data is fetched
    chartsFetchedRef.current = false;
    membersFetchedRef.current = false;

    setStartDate(employerGroupStore?.selectedDuration?.startDate);
    setEndDate(employerGroupStore?.selectedDuration?.endDate);
    setAreDatesReady((prev) => prev + 1);
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  // ✅ Reset refs when measure changes so new measure data is fetched
  useEffect(() => {
    chartsFetchedRef.current = false;
    membersFetchedRef.current = false;
  }, [careQualityStore?.currentMeasure]);

  const [loader] = useState<any>(<Loader />);

  const getCareQualityMeasuresTitle = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          fontSize="18px"
          fontType="semiBold"
          lineHeight="21.78px"
          textColor={patientAccessTheme.palette.text.highemphasis}
          margin="0px 10px 0px 0px"
        >
          {messages.TITLE}
        </Typography>
        <DashedStandardDropdown
          options={careQualityStore?.careQualityMeasuresList}
          displayValue={careQualityStore?.careQualityMeasuresList}
          value={careQualityStore?.currentMeasure}
          width="150px"
          handleChange={(e: any) => {
            const value = e.target.value as string;
            const pathDetails: any[] = [];
            pathDetails.push([
              'text',
              'Care Gaps',
              {
                color: patientAccessTheme.palette.primary[500],
                fontWeight: 500,
              },
              () => navigate(CARE_QUALITY),
            ]);
            pathDetails.push([
              'text',
              value,
              {
                color: patientAccessTheme.palette.text.highemphasis,
                fontWeight: 600,
              },
            ]);
            careQualityStore.setPathDetails(pathDetails);
            careQualityStore.setsubMeasure(
              toJS(careQualityStore.careQualityMeasuresSubMeasure.get(value)) ||
              '',
            );
            careQualityStore.setcurrentMeasure(value);
            careQualityStore.setRuleId(
              toJS(careQualityStore.careQualityMeasureRuleID.get(value)) || '',
            );
            navigate(CARE_QUALITY_INTERNAL);
          }}
          MenuProps={{
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            style: { height: '600px', width: '700px' },
            classes: { paper: classes.scroll },
          }}
        />
      </div>
    );
  };

  const SummaryCards = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '1182px',
      },
      queryIconGrid: { padding: '10px 0px 10px 22px' },
      queryDataOverallGrid: {
        margin: '10px 10px 10px 0px',
        height: '44px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
        width: '1176px',
        borderRadius: '4px',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataTypography: {
        padding: '10px 10px',
        height: '44px',
        borderRight: '1px solid #DADEEF',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataGrid: {
        maxWidth: '400px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '60px',
      },
      editQueryGrid: {
        padding: '10px 40px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
      },
      tooltip: {
        backgroundColor: patientAccessTheme.palette.grey[900],
        padding: '10px',
        fontSize: '13px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '16px',
        color: patientAccessTheme.palette.status.white,
      },
      arrow: {
        color: patientAccessTheme.palette.grey[900],
        marginLeft: '50px',
      },
      popper: { marginTop: '-20px', marginLeft: '-20px' },
      tableHeader: {
        height: '48px',
        backgroundColor: patientAccessTheme.palette.grey[300],
        borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': { paddingLeft: '32px' },
        textAlign: 'left',
        color: patientAccessTheme.palette.text.mediumemphasis,
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 400,
      },
      tableRow: {
        height: '56px',
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        color: patientAccessTheme.palette.text.mediumemphasis,
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 400,
        '&:first-child': { paddingLeft: '32px' },
        '& td:first-child': { paddingLeft: '32px' },
        '& td:last-child': { paddingRight: '20px' },
      },
      headerText: {
        fontSize: '12px',
        fontHeight: '12px',
        fontWeight: 500,
        color: patientAccessTheme.palette.text.highemphasis,
        width: '150px',
        display: 'flex',
        alignItems: 'center',
      },
      headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '120px',
        '& .sortIcon': { visibility: 'hidden' },
        '&:hover .sortIcon': { visibility: 'visible' },
      },
      iconButton: { padding: 0, marginLeft: '4px' },
    });

    const { classes } = useStyles();
    const messages = careQualityInternalMessages.CARE_QUALITY_INTERNAL_PAGE;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [activeSortField, setActiveSortField] = useState<string>('');

    const handleMemberClick = (member_id: string) => {
      if (member_id) {
        memberSummaryStore.setPathDetails([
          [
            messages.breadCrumb.text,
            messages.breadCrumb.careNavigation,
            { color: patientAccessTheme.palette.primary[500], fontWeight: 500 },
            () => navigate(-1),
          ],
        ]);
        navigate(PATIENT_DETAILS, { state: { memberId: member_id } });
      }
    };

    const formatEmployerGroupNameForTable = (member_id: string) => (
      <Grid container direction="row">
        <Grid>
          <Button
            width="100%"
            variant="text"
            justifyContent="left"
            styleProps={{ padding: '6px 0px' }}
            onClick={() => handleMemberClick(member_id)}
            label={
              <Typography
                style={{
                  fontSize: '14px',
                  lineHeight: '28px',
                  color: patientAccessTheme.palette.primary.main,
                  fontWeight: 500,
                  margin: '0px 0px 0px 0px',
                  background: `linear-gradient(to right, ${patientAccessTheme.palette.primary[500]} 50%, rgba(255, 255, 255, 0) 0%)`,
                  backgroundPosition: 'bottom',
                  backgroundRepeat: 'repeat-x',
                  backgroundSize: '6px 1px',
                }}
              >
                {member_id}
              </Typography>
            }
          />
        </Grid>
      </Grid>
    );

    const handleClick = (
      event: React.MouseEvent<HTMLElement>,
      field: string,
    ) => {
      setAnchorEl(event.currentTarget);
      setActiveSortField(field);
    };

    const handleClose = () => setAnchorEl(null);

    const handleSortSelect = (value: string) => {
      let order: 'asc' | 'desc' = 'asc';
      if (value === 'asc' || value === 'Low') {
        order = 'asc';
      }
      if (value === 'desc' || value === 'High') {
        order = 'desc';
      }

      // ✅ Reset member ref so sort triggers a fresh fetch
      membersFetchedRef.current = false;

      setSortOrder(order);
      setSortField(activeSortField || 'member_unique_id');
      setPageNumber(1);
      handleClose();
    };

    const alphabeticalFields = [
      'flag',
      'primary_care',
      'provider_speciality',
      'pcp_speciality',
    ];
    const memberColumns = [
      {
        id: 'member_unique_id',
        accessorKey: 'member_unique_id',
        header: (
          <Grid className={classes.headerContainer}>
            <Typography className={classes.headerText}>
              {'Member Id'}
              <IconButton
                className="sortIcon"
                onClick={(event) => handleClick(event, 'member_unique_id')}
                size="large"
              >
                <SvgDropDown />
              </IconButton>
            </Typography>
          </Grid>
        ),
        footer: 'Member Id',
        sticky: 'left',
        size: 120,
        cell: ({ getValue }: any) => (
          <>{formatEmployerGroupNameForTable(getValue())}</>
        ),
      },
      {
        id: 'flag',
        accessorKey: 'flag',
        header: (
          <Grid className={classes.headerContainer}>
            <Typography className={classes.headerText}>
              {'Status'}
              <IconButton
                className="sortIcon"
                onClick={(event) => handleClick(event, 'flag')}
                size="large"
              >
                <SvgDropDown />
              </IconButton>
            </Typography>
          </Grid>
        ),
        footer: 'Status',
        sticky: 'left',
        size: 100,
        cell: ({ getValue }: any) => {
          const value = getValue();
          return (
            <>
              {value === 'met'
                ? getMediumEmphasisText('Compliant')
                : value === 'Notmet'
                  ? getMediumEmphasisText('Not-Compliant')
                  : value === 'Not Enough Data'
                    ? getMediumEmphasisText('Not Enough Data')
                    : '-'}
            </>
          );
        },
      },
      {
        id: 'primary_care',
        accessorKey: 'primary_care',
        header: (
          <Grid className={classes.headerContainer}>
            <Typography className={classes.headerText}>
              {'Primary Care'}
              <IconButton
                className="sortIcon"
                onClick={(event) => handleClick(event, 'primary_care')}
                size="large"
              >
                <SvgDropDown />
              </IconButton>
            </Typography>
          </Grid>
        ),
        footer: 'Primary Care',
        sticky: 'left',
        size: 100,
        cell: ({ getValue }: any) => {
          const value = getValue();
          return (
            <>{value ? getMediumEmphasisText(value) : getMediumEmphasisText('NO')}</>
          );
        },
      },
      {
        id: 'pcp_npi',
        accessorKey: 'pcp_npi',
        header: (
          <Grid className={classes.headerContainer}>
            <Typography className={classes.headerText}>
              {'Primary Care NPI'}
              <IconButton
                className="sortIcon"
                onClick={(event) => handleClick(event, 'pcp_npi')}
                size="large"
              >
                <SvgDropDown />
              </IconButton>
            </Typography>
          </Grid>
        ),
        footer: 'Primary Care NPI',
        sticky: 'left',
        size: 120,
        cell: ({ getValue }: any) => {
          const value = getValue();
          return <>{value ? getMediumEmphasisText(value) : '-'}</>;
        },
      },
      {
        id: 'pcp_speciality',
        accessorKey: 'pcp_speciality',
        header: (
          <Grid className={classes.headerContainer}>
            <Typography className={classes.headerText}>
              {'Primary Care Speciality'}
              <IconButton
                onClick={(event) => handleClick(event, 'pcp_speciality')}
                className="sortIcon"
                size="large"
              >
                <SvgDropDown />
              </IconButton>
            </Typography>
          </Grid>
        ),
        footer: 'Primary Care Speciality',
        sticky: 'left',
        textAlign: 'left',
        size: 80,
        cell: ({ getValue }: any) => {
          const value = getValue();
          return (
            <div style={{ textAlign: 'left' }}>
              {value ? getMediumEmphasisText(value) : '-'}
            </div>
          );
        },
      },
      {
        id: 'provider_npi',
        accessorKey: 'provider_npi',
        header: (
          <Grid className={classes.headerContainer}>
            <Typography className={classes.headerText}>
              {'Provider NPI'}
              <IconButton
                onClick={(event) => handleClick(event, 'provider_npi')}
                className="sortIcon"
                size="large"
              >
                <SvgDropDown />
              </IconButton>
            </Typography>
          </Grid>
        ),
        footer: 'Provider NPI',
        sticky: 'left',
        size: 80,
        cell: ({ getValue }: any) => {
          const value = getValue();
          return (
            <div style={{ textAlign: 'left' }}>
              {value ? getMediumEmphasisText(value) : '-'}
            </div>
          );
        },
      },
      {
        id: 'provider_speciality',
        accessorKey: 'provider_speciality',
        header: (
          <Grid className={classes.headerContainer}>
            <Typography className={classes.headerText}>
              {'Provider Speciality'}
              <IconButton
                onClick={(event) => handleClick(event, 'provider_speciality')}
                className="sortIcon"
                size="large"
              >
                <SvgDropDown />
              </IconButton>
            </Typography>
          </Grid>
        ),
        footer: 'Provider Speciality',
        sticky: 'left',
        size: 120,
        cell: ({ getValue }: any) => {
          const value = getValue();
          return <>{value ? getMediumEmphasisText(value) : '-'}</>;
        },
      },
    ];

    return (
      <Grid container className={classes.root}>
        <CohortFilterBar />
        <Grid style={{ display: 'flex', marginBottom: '29px' }}>
          <Grid style={{ marginRight: '24px' }}>
            <OverviewCard
              title={messages.SUMMARY_CARDS.ELIGIBLE_MEMBERS}
              value={summaryCards.eligible?.toString()}
              rootStyles={{ width: '176px', height: '100px' }}
              showClickHere={false}
            />
          </Grid>
          <Grid style={{ marginRight: '24px' }}>
            <OverviewCard
              title={messages.SUMMARY_CARDS.COMPLIANT}
              value={summaryCards.compliant?.toString()}
              rootStyles={{ width: '176px', height: '100px' }}
              barStyles={{
                width: '4px',
                margin: '4px 10px 0px 0px',
                height: '32px',
                background: '#9DDDEB',
              }}
              showClickHere={false}
            />
          </Grid>
          <Grid style={{ marginRight: '24px' }}>
            <OverviewCard
              title={messages.SUMMARY_CARDS.NON_COMPLIANT}
              value={summaryCards.nonCompliant?.toString()}
              rootStyles={{ width: '176px', height: '100px' }}
              barStyles={{
                width: '4px',
                margin: '4px 10px 0px 0px',
                height: '32px',
                background: '#EDC0BB',
              }}
              showClickHere={false}
            />
          </Grid>
          <Grid style={{ marginRight: '24px' }}>
            <OverviewCard
              title={messages.SUMMARY_CARDS.NOT_ENOUGH_DATA}
              value={summaryCards.notEnoughData?.toString()}
              rootStyles={{ width: '176px', height: '100px' }}
              barStyles={{
                width: '4px',
                margin: '4px 10px 0px 0px',
                height: '32px',
                background: '#b8bbc8',
              }}
              showClickHere={false}
            />
          </Grid>
        </Grid>
        <Grid style={{ display: 'flex', marginBottom: '28px' }}>
          <Grid style={{ marginRight: '24px' }}>
            {topChart === 'Age' ? (
              <CostTrend
                dashedStandardDropdown={{
                  width: '78px',
                  height: '22px',
                  options: ['Age', 'Gender'],
                  displayValue: ['Age', 'Gender'],
                  value: topChart,
                  handleChange: (event: any) => handleChartChange(event),
                }}
                showDBIcon={false}
                chartTitle={'Member Distribution'}
                chartSubTitle={'Distribution by'}
                showClickHere={false}
                cardWidth={'778px'}
                datasetProp={ageChartData?.dataSet}
                chartWidth={'750'}
                chartHeight={'320'}
                xAxisTitle={'Age'}
                yAxisTitle={'Members'}
                sAxisTitle={' '}
                spaceBetweenTitleAndChart={'20px'}
                cardHeight={'420px'}
                chartType={'stackedcolumn2d'}
                xAxisValues={ageChartData?.labels}
                isLoading={memberDistLoading}
              />
            ) : topChart === 'Risk' ? (
              <CostTrend
                showDBIcon={false}
                chartTitle={messages.SCATTER_PLOT.TITLE}
                chartSubTitle=""
                showClickHere={false}
                cardWidth={'778px'}
                datasetProp={riskChartData?.dataSet}
                chartWidth={'750'}
                chartHeight={'320'}
                xAxisTitle={'Age Groups'}
                yAxisTitle={'Members'}
                sAxisTitle={' '}
                spaceBetweenTitleAndChart={'20px'}
                cardHeight={'420px'}
                chartType={'stackedcolumn2d'}
                xAxisValues={riskChartData?.labels}
              />
            ) : (
              <CardComponent
                title={'Member Distribution'}
                subTitle={
                  <Grid
                    container
                    style={{ marginBottom: '16px', gap: '15px' }}
                    sx={{
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      fontSize="12px"
                      lineHeight="24px"
                      textColor={patientAccessTheme.palette.text.mediumemphasis}
                      margin="0px 0px 0px 0px"
                    >
                      {'Distribution by'}
                    </Typography>
                    <DashedStandardDropdown
                      width={'78px'}
                      height={'22px'}
                      options={['Age', 'Gender']}
                      displayValue={['Age', 'Gender']}
                      value={topChart}
                      handleChange={(event: any) => handleChartChange(event)}
                    />
                  </Grid>
                }
                width="778px"
                height="420px"
                body={
                  memberDistLoading ? (
                    <CircularLoader />
                  ) : (
                    <Grid
                      container
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <Grid style={{ width: '50%' }}>
                        <PieChartWithoutCard
                          data={genderChartData?.male}
                          showValues={true}
                          showLegend={true}
                          legend={genderChartData?.legend}
                          chartName={'Male Distribution'}
                        />
                      </Grid>
                      <Grid style={{ width: '50%' }}>
                        <PieChartWithoutCard
                          data={genderChartData?.female}
                          showValues={true}
                          showLegend={true}
                          legend={genderChartData?.legend}
                          chartName={'Female Distribution'}
                        />
                      </Grid>
                    </Grid>
                  )
                }
              />
            )}
          </Grid>
          <CardComponent
            title={messages.SERVICE_TYPE.TITLE}
            titleSubTitleMargin={'10px'}
            width={'376px'}
            height={'420px'}
            showSearchDB={true}
            padding={'20px 14px 16px 20px'}
            body={
              <Grid container>
                <PieChartWithoutCard
                  data={topServiceType.data}
                  showValues={true}
                  showLegend={true}
                  legend={topServiceType.legend}
                  chartName={''}
                />
              </Grid>
            }
          />
        </Grid>
        <Grid style={{ display: 'flex' }}>
          <Grid style={{ marginTop: '14px', marginBottom: '28px' }}>
            <CardComponent
              title={messages.MEMBER_TABLE.TITLE}
              subTitle={messages.MEMBER_TABLE.SUB_TITLE}
              width="1178px"
              height="800px"
              body={
                isMemberDetailsLoading ? (
                  <CircularLoader />
                ) : (
                  <>
                    <Grid style={{ marginTop: '14px' }}>
                      <Table
                        classNameForTableHeaderRowTop={classes.tableHeader}
                        classNameForTableDataRow={classes.tableRow}
                        classNameForTableHeader={classes.tableHeader}
                        columns={memberColumns}
                        data={membersDetails}
                        onHoverRowData={() => { }}
                        isManualPagination={false}
                        tableHeight="680px"
                        showPagination={false}
                        pageSize={pageSize}
                        controlledPageSize={pageSize}
                        isMemberTable={true}
                        controlledPageIndex={0}
                        rightAlignAmounts={[4, 5]}
                      />
                    </Grid>
                    <Grid
                      style={{
                        position: 'absolute',
                        right: '24px',
                        marginTop: '16px',
                        bottom: '16px',
                      }}
                    >
                      <Pagination
                        count={totalPages}
                        page={pageNumber}
                        onChange={handlePageChange}
                      />
                    </Grid>
                  </>
                )
              }
              topRightItem={
                <Grid
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >
                  <DynamicFilter
                    filterOptions={filterOptions}
                    resetKey={resetKey}
                  />
                  <Button
                    label="Reset Filter"
                    onClick={() => {
                      membersFetchedRef.current = false;
                      setSelectedStatus(null);
                      setPageNumber(1);
                      setResetKey((prev) => prev + 1);
                    }}
                  />
                </Grid>
              }
            />
          </Grid>
        </Grid>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          {alphabeticalFields.includes(activeSortField || '') ? (
            <>
              <MenuItem onClick={() => handleSortSelect('asc')}>A → Z</MenuItem>
              <MenuItem onClick={() => handleSortSelect('desc')}>
                Z → A
              </MenuItem>
            </>
          ) : (
            <>
              <MenuItem onClick={() => handleSortSelect('High')}>
                High → Low
              </MenuItem>
              <MenuItem onClick={() => handleSortSelect('Low')}>
                Low → High
              </MenuItem>
            </>
          )}
        </Popover>
      </Grid>
    );
  };

  return (
    <>
      {loading ? (
        loader
      ) : (
        <div>
          <Grid container className={classes.root}>
            <Grid style={{ marginBottom: '19px' }}>
              <Breadcrumbs itemList={careQualityStore.pathDetails} />
            </Grid>
            <Grid
              style={{
                marginBottom: '36px',
                width: '1182px',
                position: 'relative',
              }}
            >
              <PageTitleAndSubTitle
                title={getCareQualityMeasuresTitle()}
                subTitle={messages.SUB_TITLE.PART1}
                subTitleStartPeriod={formatDate(
                  moment(
                    employerGroupStore.employerGroupResponseData.max_claim_date,
                  )
                    .subtract(1, 'year')
                    .startOf('month')
                    .add(1, 'month')
                    .utc()
                    .toString(),
                  'MMMM Y',
                )}
                subTitleMiddleString={messages.SUB_TITLE.PART2}
                subTitleEndPeriod={formatDate(
                  employerGroupStore.employerGroupResponseData.max_claim_date,
                  'MMMM Y',
                )}
                showQueryDataButton={checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )}
                queryButtonText={
                  cohortDetailsStore.cohortDetailsList?.length > 0 &&
                    cohortDetailsStore.cohortDetailsList[0].category !== ''
                    ? 'Edit Cohort'
                    : 'Add Cohort'
                }
                queryDataAction={() => {
                  if (
                    checkUserAccess(
                      UserAccessConstants.COHORT_DETAILS,
                      loginPageStore.userResponse.role.name,
                      loginPageStore.userFeatures,
                    )
                  ) {
                    openModal();
                  }
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '-1px',
                  left: '400px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  {COMMON_TEXTS.FOR}
                </Typography>
                <Grid className={classes.duration}>
                  {getLast12MonthsRange(
                    employerGroupStore.employerGroupResponseData.max_claim_date,
                  )}
                </Grid>
                <Grid style={{ display: 'none' }}>
                  <EditDurationModal
                    isYearGrid={false}
                    handleDateChange={handleDateChange}
                  />
                </Grid>
              </div>
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>
            <Grid>
              {selectedTabIndex === 0 && <SummaryCards />}
              {selectedTabIndex === 1 && (
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                />
              )}
            </Grid>
            <div id="scroll-top-element"></div>
          </Grid>
          {pageScrollDown('scroll-top-element')}
        </div>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={startDate}
        endDate={endDate}
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
        existingMemberUniqueIds={memberIds}
      />
      <FeatureAccessModal
        open={openFeatureAccessModal}
        handleClose={() => setOpenFeatureAccessModal(false)}
        access={checkUserAccess(
          UserAccessConstants.COHORT_DETAILS,
          loginPageStore.userResponse.role.name,
          loginPageStore.userFeatures,
        )}
      />
    </>
  );
});

export default CareQualityInternalPage;
